export const SET_APPLICATION_STATE = 'SET_APPLICATION_STATE';
export const GET_APPLICATION_STATE = 'GET_APPLICATION_STATE';
export const CLEAR_APPLICATION_STATE = 'CLEAR_APPLICATION_STATE';

